import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/uaxios'
import './plugins/element'
import './plugins/axios';
import './assets/css/common.scss'
import './assets/css/loading.scss'
import { getProxy } from './plugins/axios';

import VueSimCaptcha from 'vue-sim-captcha'
Vue.use(VueSimCaptcha)
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.directive('focus', function(el) {
	el.focus()
})

//选择组织架构组件
import SelectUser from './components/SelectUser.vue';
Vue.component('SelectUser', SelectUser)

import ExportTip from "./components/header-comp/export-tip"
Vue.component("export-tip", ExportTip);


Vue.config.productionTip = false;

getProxy().then(()=>{
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
	
	router.beforeEach((to, from, next) => {
		if (to.path == '/' || to.path == '/login') {
			next();
			return
		}
		store.commit("setBreadcrumb", {
			path: to.path,
			...to.meta, // title keepalive isNav
		});
		next()
	});
})
